module.exports = __webpack_public_path__ + "static/img/cr1.cbf2435.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img_grande/cr1.png
// module id = F204
// module chunks = 1